import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import './ProductsPmsHeader.css';

function AiFrontOfficeHeader() {
    const { t } = useTranslation();

    return (
        <div className='product-header' style={{ backgroundImage: 'url(/images/ai-front-office-bg.png)' }}>
            <div className='page-content d-flex align-items-center' >
                <div className='col-6 d-flex flex-column'>
                    <div className='chip-light-blue'>
                         {t('AI Front Desk Agent')}
                    </div>
                    <h1>{t('AI Front Office Agent — Automate Guest Requests & Enhance Operations')}</h1>
                    <p className='body-large mt-2'>
                        {t('Prostay’s AI Front Office Agent is your 24/7 digital concierge — responding to guest messages, routing requests to the right departments, and maintaining exceptional service across.')}
                    </p>
                </div>
                <div className='col img-wrapper'>
                    <img src='/images/ai-front-office-img.png' alt={"AI Front Desk Agent"}/>
                </div>
            </div>
        </div>
    );
}

export default AiFrontOfficeHeader;
